<div>
    <div *ngIf="fileName" class="fx-row fx-layout-align-start-center fx-layout-gap-10">
        <span>{{ fileName }}</span>
        <button mat-icon-button>
            <mat-icon
                svgIcon="close"
                [matTooltip]="'common.tooltips.cancel' | translate"
                (click)="remove.emit()"
                (keydown.enter)="remove.emit()"
            >
            </mat-icon>
        </button>
    </div>
    <div class="progress">
        <div class="progress-bar" role="progressbar" [ngStyle]="{ width: progress + '%' }"></div>
        <div class="percentage fx-layout-align-center">{{ progress }}%</div>
    </div>
</div>
